export class pbbConstants {
    public static readonly PBBWIDGETCAROUSEL: string = 'precreated-bb-widget-carousel';
    public static readonly MINSLIDESEFFECT: number = 20;
    public static readonly PBBWIDGET: string = 'widget';
    public static readonly PBBSTATICINDEX: number = 2;
    public static readonly HOME_SPORT: number = 0;
    public static readonly LADS_BRAND: string = 'ladbrokes';
    public static readonly FOOTBALL2025: string = 'football-2025';
    public static readonly LOCATION_HOME: string = 'home';
    public static readonly LOCATION_EDP: string = 'edp';
    public static readonly BETBUILDERTYPE: string = 'precreatedBetBuilder';
    public static readonly BETBUILDER: string = 'bet-builder';
    public static readonly BUILDYOURBET: string = 'build-your-bet';
    public static readonly SPECIALS: string = 'specials';
    public static readonly BUILDYOUROWNBET: string = 'build your own bet';
    public static readonly VIRTUAL: string = 'VIRTUAL';
    public static readonly SUBTAB: string = 'pbbWidget';
    public static readonly FEATURED_MODULE: string = 'featuredModule';
    public static readonly SPORT_SEGMENT = {
        '0': 'home',
        '16': 'sport/football',
    };
}
